<template>
  <b-form>
    <b-form-group class="m-2">
      <b-form-select
              name="coordinator"
              :options=options
              v-model=coordinatorId
      ></b-form-select>
    </b-form-group>

    <div class="mt-5 text-right">
      <b-button type="button" v-on:click="transferCoordinator" variant="danger" :disabled="school.coordinator && school.coordinatorId === coordinatorId">Rolle übertragen</b-button>
    </div>
  </b-form>
</template>
<script>
export default {
  name: 'SchoolsCoordinator',
  props: ['school', 'users'],

  data: function () {
    return {
      coordinatorId: null,
      options: [{value: null, text: 'Kolleg*in auswählen...', disabled: true}]
    }
  },

  watch: {
    users: {
      immediate: true,
      handler (users) {
        users.forEach((user) => {
          if (user.id === this.school.coordinatorId) {
            return
          }

          this.options.push({
            value: user.id,
            text: user.firstname + ' ' + user.lastname + ' (' + user.email + ')'
          })
        })
      }
    }
  },

  methods: {
    transferCoordinator () {
      this.axios.put('/schools/' + this.school.id + '/coordinator', JSON.stringify({id: this.coordinatorId}))
        .then((rsp) => {
          this.school.coordinatorId = rsp.data.coordinatorId
          this.$eventHub.$emit('info', 'Rolle erfolgreich übertragen')
        })

        .catch((err) => {
          this.$eventHub.$emit('error', err)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/schools/Coordinator.vue